import * as $modal from './_modal'

export interface IInitOptions {
    pageName: string
    pageNameUnique: string
    pagePrefix: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pageNameUnique + ' a').click(function (e) {
        $modal.load($(this).attr('data-link'), {}, false, true, true)
        e.preventDefault()
    })
}
